import { render, staticRenderFns } from "./MisRequisiciones.vue?vue&type=template&id=23c367c6&scoped=true"
import script from "./MisRequisiciones.vue?vue&type=script&lang=js"
export * from "./MisRequisiciones.vue?vue&type=script&lang=js"
import style0 from "./MisRequisiciones.vue?vue&type=style&index=0&id=23c367c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c367c6",
  null
  
)

export default component.exports